export default "__VITE_ASSET__$fiVcCqs__"